module.exports = "https://qp-assets.quero.com/assets/images/landing/rectangle.svg?96182ac990a3c4b47a9bb8dd77eefc2d";